import axios from "axios";

const axiosGet = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosGet.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosGet.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const errorMessage =
        error.response.data?.error?.message || "An error occurred";

      if (
        errorMessage === "Unauthenticated." ||
        errorMessage === "Unauthorized"
      ) {
        localStorage.clear();

        setTimeout(() => {
          window.location.replace("/login");
        }, 100);
      }

      return Promise.reject(errorMessage);
    } else if (error.request) {
      console.error("Request error", error.request);
    } else {
      console.error("Error", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosGet;
